// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationOffsetsSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.037 2c1.553 0 2.939.74 3.847 1.9.35-.109.721-.167 1.106-.167 2.13 0 3.858 1.79 3.858 3.999 0 .464-.076.91-.216 1.325a5.203 5.203 0 0 1 1.63 3.807c0 2.835-2.216 5.132-4.951 5.132a4.791 4.791 0 0 1-2.285-.578V21.5c0 .276-.216.5-.483.5h-1.93a.491.491 0 0 1-.482-.5v-4.848a4.793 4.793 0 0 1-2.284.578c-2.735 0-4.952-2.298-4.952-5.132 0-1.794.888-3.373 2.233-4.29a5.365 5.365 0 0 1-.043-.676C5.085 4.298 7.302 2 10.037 2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationOffsetsSolid;
